// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_gz","advertCardPhoto__image":"c-a_gA"};